<template>
  <div>
    <b-container class="pt-4 pb-4">
      <b-card class="text-center">
        <template v-if="order.payment_status === 'failed'">
          <div class="state-badge error">
            <font-awesome-icon icon="xmark" />
          </div>
          <h1>Betaling mislukt</h1>
          <p>
            De betaling is helaas niet gelukt. Je kunt het opnieuw proberen
            zolang je tickets nog gereserveerd zijn.
          </p>
          <b-button :to="'/'" variant="primary"
            >Terug naar het overzicht</b-button
          >
        </template>
        <template v-else-if="order.payment_status === 'expires'">
          <div class="state-badge error">
            <font-awesome-icon icon="xmark" />
          </div>
          <h1>Betaling verlopen</h1>
          <p>
            De betaaltermijn is verlopen. Je gereserveerde tickets zijn
            vrijgegeven. Plaats een nieuwe bestelling om opnieuw tickets te
            reserveren.
          </p>
          <b-button :to="'/'" variant="primary"
            >Terug naar het overzicht</b-button
          >
        </template>
        <template
          v-else-if="
            order.payment_status === 'open' ||
            order.payment_status === 'pending'
          "
        >
          <div class="state-badge warning mb-3">
            <font-awesome-icon icon="check" />
          </div>
          <h1>Wachten op betaling</h1>
          <p>
            We wachten momenteel op je betaling. Zodra de betaling is afgerond,
            wordt deze pagina automatisch bijgewerkt.
          </p>
          <b-button :to="'/'" variant="primary"
            >Terug naar het overzicht</b-button
          >
        </template>
        <template v-else-if="order.payment_status === 'canceled'">
          <div class="state-badge error">
            <font-awesome-icon icon="xmark" />
          </div>
          <h1>Bestelling geannuleerd</h1>
          <p>
            Je hebt de bestelling geannuleerd. Wil je alsnog tickets bestellen?
            Ga terug naar het overzicht om opnieuw te beginnen.
          </p>
          <b-button :to="'/'" variant="primary"
            >Terug naar het overzicht</b-button
          >
        </template>
        <template v-else-if="order.payment_status === 'paid'">
          <div class="state-badge success mb-3">
            <font-awesome-icon icon="check" />
          </div>
          <h1>Bedankt voor je bestelling!</h1>
          <p>
            Je betaling is succesvol ontvangen. Je tickets worden nu gegenereerd
            en verschijnen binnen enkele minuten in je mailbox.
          </p>
          <b-button to="/account" variant="primary">Bekijk je tickets</b-button>
        </template>
      </b-card>
    </b-container>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: "Bestelling status",
  },
  components: {},
  data() {
    return {
      order: {},
      polling: null,
    };
  },
  computed: {},
  methods: {
    startPolling: function () {
      if (this.polling) return;

      this.polling = setInterval(() => {
        this.getOrderStatus();
      }, 3000);
    },
    getOrderStatus() {
      this.$axios
        .get(`https://api.tixgo.nl/order/${this.$route.params.order_id}`)
        .then((response) => {
          if (!response.data) return;

          this.order = response.data;

          if (
            ["paid", "canceled", "expires", "failed"].includes(
              this.order.payment_status,
            )
          ) {
            clearInterval(this.polling);
          }
        })
        .catch(console.error);
    },
  },
  created() {
    this.getOrderStatus();
    this.startPolling();
  },
  beforeDestroy() {
    clearInterval(this.polling);
  },
};
</script>

<style scoped>
.payment-state {
  max-width: 480px;
  margin: auto;
}

.state-badge {
  width: 80px;
  height: 80px;
  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 2rem;
  margin: auto;
}

.state-badge.success {
  background: #e8f7ee;
  color: #22c55e;
}

.state-badge.warning {
  background: #fff6e6;
  color: #f59e0b;
}

.state-badge.error {
  background: #fdecec;
  color: #ef4444;
}
</style>
